export default "__VITE_ASSET__CgrgL61M__"